import { useContext, useRef } from 'react';
import { CanvasContext } from '../upload-image/CanvasContext';
import CropTool from './CropTool';
import RotateTool from './RotateTool';
import TransformButton from 'components/buttons/TransformButton';
import CanvasRotateTool from './CanvasRotateTool';

export default function TransformTool({ isActive }) {
  const { transformMode, setTransformMode, requestRotateExit } =
    useContext(CanvasContext);

  const cropToolRef = useRef(null);

  if (!isActive) return null;

  if (transformMode === 'home') {
    return (
      <div className="mx-auto flex flex-wrap items-center justify-center gap-8">
        <TransformButton
          setTransformMode={setTransformMode}
          action="crop"
          label="crop"
        />

        {/* <TransformButton
          setTransformMode={setTransformMode}
          action="rotate"
          label="rotate"
        /> */}

        <TransformButton
          setTransformMode={setTransformMode}
          action="canvas"
          label="flip"
        />
      </div>
    );
  }

  if (transformMode === 'crop') {
    return (
      <div className="mx-auto flex items-center gap-4">
        <button
          className="p-2 rounded-lg bg-white text-stone-800"
          onClick={() => {
            cropToolRef.current?.clearCropOverlay?.();
            setTransformMode('home');
          }}
        >
          ← Back
        </button>

        <CropTool ref={cropToolRef} />
      </div>
    );
  }

  if (transformMode === 'canvas') {
    return (
      <div className="mx-auto flex items-center gap-4 flex-wrap">
        <button
          className="p-2 rounded-lg bg-white text-stone-800 whitespace-nowrap"
          onClick={() => setTransformMode('home')}
        >
          ← Back
        </button>
        <CanvasRotateTool />
      </div>
    );
  }

  if (transformMode === 'rotate') {
    return (
      <div className="mx-auto flex items-center gap-4 w-full">
        <button
          className="hidden sm:block p-2 rounded-lg bg-white text-stone-800 whitespace-nowrap"
          onClick={() => {
            const goHome = () => setTransformMode('home');

            // ✅ Trigger the “Apply rotation?” modal if rotation hasn't been applied
            if (typeof requestRotateExit === 'function') {
              requestRotateExit(goHome);
            } else {
              goHome();
            }
          }}
        >
          ← Back
        </button>

        <RotateTool
          onCancel={() => setTransformMode('home')}
          onApplyDone={() => setTransformMode('home')}
        />
      </div>
    );
  }

  return null;
}
